<!-- 此component用來選取filter所顯示的TAG瀏覽 -->
<template lang="html">
<div class="v-tag-editor">
  <v-tag-list v-model="editableTags" :theme="theme"></v-tag-list>
</div>
</template>

<script>
import VTagList from 'v-tag-list'
export default {
  name: 'v-tag-editor',
  components: {VTagList},

  props: {
    value: {
      type: Array,
      default: () => [],
      required: true
    },
    theme: {
      type: [String, Object],
    },
    separator: {
      type: String,
      default: ' '
    },
  },
  created() {
		
	},
	mounted() {
		
	},
	methods: {
	},
  computed: {
    editableTags: {
      get () {
		
        return this.value || [];
      },
      set (newValue) {
		
		this.$store.state.checkedDeps = null;
		this.$store.state.checkedLevels = [];
      	this.$store.state.checkedTypes = [];
      	this.$store.state.checkedTimes = null;
      	this.$store.state.checkedSecrets = [];

		this.$store.state.resourceList.actual_depid = null;
		this.$store.state.resourceList.level = null;
      	this.$store.state.resourceList.type = null;
      	this.$store.state.resourceList.startTime = null;
      	this.$store.state.resourceList.endTime = null;
      	this.$store.state.resourceList.secret = null;

        this.$store.state.resourceList.currentPage = 1;
        this.$store.state.resourceList.offset = 0;

      	if(newValue.length > 0) {
          let levelValue = 0;
          let levelNum = 0;
          let typeNum = 0;
          let index = 0;
      		for(let i = 0 ; i < newValue.length ; i++) {
      			if(newValue[i] === 'Level 1' || newValue[i] === 'Level 2' || newValue[i] === 'Level 3' || newValue[i] === 'Level 4') {
              levelNum++;
              if(levelNum === 1) {
      				  this.$store.state.resourceList.level = Number(newValue[i].split(' ')[1]);
                levelValue = Number(newValue[i].split(' ')[1]);
              } else if(levelNum === 2) {
                levelValue = levelValue * Number(newValue[i].split(' ')[1]);
                if(levelValue === 2) {
                  this.$store.state.resourceList.level = 5;  
                } else if(levelValue === 3) {
                  this.$store.state.resourceList.level = 6;
                } else if(levelValue === 4) {
                  this.$store.state.resourceList.level = 7;
                } else if(levelValue === 6) {
                  this.$store.state.resourceList.level = 8;
                } else if(levelValue === 8) {
                  this.$store.state.resourceList.level = 9;
                } else if(levelValue === 12) {
                  this.$store.state.resourceList.level = 10;
                } 
              } else if(levelNum === 3) {
                levelValue = levelValue * Number(newValue[i].split(' ')[1]);
                if(levelValue === 6) {
                  this.$store.state.resourceList.level = 11;  
                } else if(levelValue === 8) {
                  this.$store.state.resourceList.level = 12;
                } else if(levelValue === 12) {
                  this.$store.state.resourceList.level = 13;
                } else if(levelValue === 24) {
                  this.$store.state.resourceList.level = 14;
                }
              } else if(levelNum === 4) {
                this.$store.state.resourceList.level = 15;
              }
      				this.$store.state.checkedLevels.push(newValue[i]);
      			} else if(newValue[i] === '影片' || newValue[i] === '文件') {
              typeNum++;
              if(typeNum === 1) {
      				  if(newValue[i] === '影片') {
          				this.$store.state.resourceList.type = 'video'; 
        			  }  else {
          				this.$store.state.resourceList.type = 'doc'; 
        			  }
              } else {
                this.$store.state.resourceList.type = 'all';  
              }
      				this.$store.state.checkedTypes.push(newValue[i]);
      			} else if(newValue[i] === '今日' || newValue[i] === '最近 7 天' || newValue[i] === '最近 30 天' || newValue[i] === '最近一年') {
      				
              if(newValue[i] === '今日' && index < 1) {
                index = 1;
              } else if(newValue[i] === '最近 7 天' && index < 2) {
                index = 2;
              } else if(newValue[i] === '最近 30 天' && index < 3) {
                index = 3;
              } else if(newValue[i] === '最近一年' && index < 4) {
                index = 4;
              }

              let day = new Date().getDate(); 
      				let month = new Date().getMonth() + 1; 
      				let year  = new Date().getFullYear(); 
      				let nowDate = month.toString() + "/" + day.toString() + "/" + year.toString();
        			if(index === 1) {
          			this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)); 
          			this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
       			  } else if(index === 2) {
          			this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 6; 
          			this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
        			} else if(index === 3) {
          			this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 29; 
          			this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400; 
        			} else {
          			this.$store.state.resourceList.startTime = parseInt((new Date(nowDate).getTime() / 1000)) - 86400 * 364;  
          			this.$store.state.resourceList.endTime = parseInt((new Date(nowDate).getTime() / 1000)) + 86400;  
        			}
      				this.$store.state.checkedTimes = newValue[i];
      			} else if(newValue[i] === '是') {
      				this.$store.state.resourceList.secret = 1;
      				this.$store.state.checkedSecrets.push(newValue[i]);
      			} else {
					for(let j = 0 ; j < this.$store.state.actualDeps.length ; j++) {
							if(newValue[i] === this.$store.state.actualDeps[j].name) {
							this.$store.state.resourceList.actual_depid = this.$store.state.actualDeps[j].id;  
							this.$store.state.checkedDeps = newValue[i];
						}
					}
				}
      		}	
      	}

				this.$store.state.checkedFilterLists = newValue;
				
				this.$emit('setURL');  
      }
    }
  }
}
</script>

<style>
	.tag {
		-webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    background-color: #f5f5f5;
	    border-radius: 10px;
	    color: #4a4a4a;
	    display: -webkit-inline-box;
	    display: -ms-inline-flexbox;
	    display: inline-flex;
	    font-size: .75rem;
	    height: 2em;
	    -webkit-box-pack: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    line-height: 1.5;
	    padding-left: .875em;
	    padding-right: .875em;
	    vertical-align: top;
	    white-space: nowrap;
	    float: left;
	    line-height: 24px;
			margin-top: 16px;
	}
			
	.tag.is-info {
    	background-color: #F5F5F5;
    	color: #222222;
    	height: 40px;
    	font-size: 14px;
    	margin-left: 8px;
		margin-top: 10px;
		position: relative;
    	border: 1px solid #EEE;
			border-radius: 2px;
    }

    .delete {
	    -webkit-touch-callout: none;
	    -webkit-user-select: none;
	    -moz-user-select: none;
	    -ms-user-select: none;
	    user-select: none;
	    -moz-appearance: none;
	    -webkit-appearance: none;
	    /*background-color: rgba(10,10,10,.2);*/
	    border: none;
	    border-radius: 290486px;
	    cursor: pointer;
	    display: inline-block;
	    font-size: 1rem;
	    height: 20px;
	    outline: 0;
	    position: relative;
	    -webkit-transform: rotate(45deg);
	    transform: rotate(45deg);
	    -webkit-transform-origin: center center;
	    transform-origin: center center;
	    vertical-align: top;
	    width: 20px;
	    margin-left: .25em;
			margin-right: -.5em;
	}

	.delete.is-small {
		height: 20px;
		width: 20px;
	}

	.delete:before {
	    height: 2px;
	    width: 50%;
	}

	.delete:before {
	    background-color: #000000;
	    content: "";
	    display: block;
	    left: 50%;
	    position: absolute;
	    top: 50%;
	    -webkit-transform: translateX(-50%) translateY(-50%);
	    transform: translateX(-50%) translateY(-50%);
	    height: 2px;
	    width: 50%;
	}

	.delete:after {
	    height: 50%;
	    width: 2px;
	}

	.delete:after, .delete:before {
	    background-color: #000000;
	    content: "";
	    display: block;
	    left: 50%;
	    position: absolute;
	    top: 50%;
	    -webkit-transform: translateX(-50%) translateY(-50%);
	    transform: translateX(-50%) translateY(-50%);
	}
</style>



// WEBPACK FOOTER //
// Tag.vue?24e2ebca